import React from "react"
import PropTypes from "prop-types"
import Footer from "./Footer"
import SEO from "./seo"

const Layout = ({ children, title, description, keywords, image, style, pathname, structuredData }) => {
  return (
    <>
      <SEO
        title={title}
        description={description}
        image={image}
        keywords={keywords}
        pathname={pathname}
        structuredData={structuredData}
      />
      <main style={style}>{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
